'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeInaraInfo = {
    fromJson: fromJson,
    get: getInaraInfo,
};

function fromJson(data) {
    var reqProps = [];
    return FirebaseObject.$fromJson(data, 'InaraInfo', reqProps, reqProps,
        function(data) { return new getInaraInfo(); }
    );
}

function getInaraInfo() {
    var key = 'InaraInfo';
    var inaraInfo = KayleeCache.get(key);

    if (inaraInfo === null) {
        inaraInfo = new InaraInfo();
        KayleeCache.put(key, inaraInfo);
    }

    return inaraInfo;
}

function InaraInfo() {
    this.$nodeType = 'inaraInfo';
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('inara'));
}

InaraInfo.prototype = Object.create(FirebaseObject.prototype);
InaraInfo.prototype.constructor = InaraInfo;

InaraInfo.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, []);
};

InaraInfo.prototype.toString = function() {
    return '[Inara Info]';
};

module.exports = KayleeInaraInfo;